export default __webpack_public_path__ + "static/media/Head_5_Ear_1_C5.c1bd127f.svg";